export default __webpack_public_path__ + "static/media/phone.49aaa20b.svg";